import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Space, theme } from 'antd';
import { filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
const { RangePicker } = DatePicker;

export default function ConsultationsFilterForm({ form, onFinish, onReset, onChangeTime }) {
    const { token } = theme.useToken();

    return (
        <Card
            size="small"
            className="consultations-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} onFinish={onFinish} form={form} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="用户memCard" name="memCard" style={filterFormItemStyle}>
                            <Input allowClear placeholder="用户memCard" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="用户昵称" name="nickName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="用户昵称" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="手机号" name="memMobile" style={filterFormItemStyle}>
                            <Input allowClear placeholder="用户手机号" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="咨询时间" name="time" style={filterFormItemStyle}>
                            <RangePicker className="ProjectRangPicker" allowClear onChange={onChangeTime} showTime />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="跟进状态" name="followStatus" style={filterFormItemStyle}>
                            <Select
                                placeholder="请选择跟进状态"
                                options={[
                                    { value: -1, label: '全部' },
                                    { value: 0, label: '未跟进' },
                                    { value: 1, label: '已跟进' },
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={onReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
